import { render, staticRenderFns } from "./PaginationLimit.vue?vue&type=template&id=0bbfb6be&"
import script from "./PaginationLimit.vue?vue&type=script&lang=js&"
export * from "./PaginationLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports